import Wrapper from '../../components/Wrapper';
import {Helmet} from 'react-helmet';
import React, {useEffect, useState} from 'react';
import DashboardHeader from '../../components/DashboardHeader';
import {useTranslation} from '../../hooks/useTranslation';
import Input from '../../components/Input';
import './index.scss';
import CorporateCreateModal from '../../components/Corporate/CorporateCreate';
import CorporateInviteModal from '../../components/Corporate/CorporateInvite';
import CorporateAccountRow from '../../components/Corporate/CorporateAccountRow';
import EditCorporatePricingModal from '../../components/EditCorporatePricingModal';
import {
  useCorporateUpdateStatusMutation,
  useGetTimezonesQuery,
  useLazyCorporateListQuery,
  useToggleCorporateCustomFormMutation,
  useToggleCustomFormMutation,
} from '../../store/builder/inspections.api';
import {useDispatch} from 'react-redux';
import {setLoader} from '../../store/builder/reducer';
import {useErrorHandler} from '../../global/ErrorsHandler';
import {useDebounce} from '../LogSheets/hooks';
import CorporateEditModal from '../../components/Corporate/CorporateEditModal';
import {toast} from 'react-toastify';
import useLoader from '../../global/UseLoadingHandler';

export default function CorporateAccount({type}) {
  const {t} = useTranslation();
  const dispatch = useDispatch();
  const [currentCorporateAccount, setCurrentCorporateAccount] = useState(null);
  const [createModal, setCreateModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [inviteModal, setInviteModal] = useState(false);
  const [pricingModal, setPricingModal] = useState(false);
  const [corporateData, setCorporateData] = useState([]);
  const [search, setSearch] = useState('');
  const [filteredCorporate, setFilteredCorporate] = useState([]);
  const [deactivateStatus, setDeactivateStatus] = useState(false);
  const [reactivateStatus, setReactivateStatus] = useState(false);
  const [turnStatus, setTurnStatus] = useState(false);

  const debouncedSearchValue = useDebounce(search, 500);

  const [
    getCorporateList,
    {
      data: corporateListData,
      error: corporateListError,
      isFetching: corporateListIsLoading,
      isSuccess: corporateListIsSuccess,
      isError: corporateListIsError,
    },
  ] = useLazyCorporateListQuery();

  const [
    changeStatus,
    {
      data: changeStatusData,
      error: changeStatusError,
      isFetching: changeStatusIsLoading,
      isSuccess: changeStatusIsSuccess,
      isError: changeStatusIsError,
    },
  ] = useCorporateUpdateStatusMutation();

  const [
    toggleCustomForm,
    {
      data: toggleCustomFormData,
      error: toggleCustomFormError,
      isFetching: toggleCustomFormIsLoading,
      isSuccess: toggleCustomFormIsSuccess,
      isError: toggleCustomFormIsError,
    },
  ] = useToggleCorporateCustomFormMutation();

  useLoader([
    changeStatusIsLoading,
    corporateListIsLoading,
    toggleCustomFormIsLoading,
  ]);

  const {
    data: timezoneData,
    error: timezoneError,
    isLoading: timezoneIsLoading,
    isSuccess: timezoneIsSuccess,
    isError: timezoneIsError,
  } = useGetTimezonesQuery();

  const [errorHandler, setErrorHandler] = useErrorHandler([
    corporateListError,
    timezoneError,
    toggleCustomFormError,
  ]);

  useEffect(() => {
    getCorporateList({status: type});
    dispatch(setLoader(true));
    setTimeout(() => {
      dispatch(setLoader(false));
    }, 1500);
  }, [type]);

  useEffect(() => {
    if (createModal || editModal || inviteModal || pricingModal) {
      document.querySelector('html').style.overflow = 'hidden';
    } else {
      document.querySelector('html').style.overflow = 'visible';
    }
  }, [createModal, editModal, inviteModal, pricingModal]);

  useEffect(() => {
    if (corporateListData) {
      setCorporateData(
        corporateListData?.map(item => ({...item, dropdown_status: false})),
      );
    }
  }, [corporateListData]);

  useEffect(() => {
    const filter = corporateData?.filter(el => {
      if (debouncedSearchValue === '') {
        return el;
      } else {
        return el?.title?.toLowerCase()?.includes(search.toLowerCase());
      }
    });
    setFilteredCorporate(filter);
  }, [debouncedSearchValue, corporateData]);

  const getCorporateListFunc = () => getCorporateList({status: type});

  const renderDeactivate = () => {
    return (
      <div className='modal'>
        <div className='modal__content'>
          <div className='modal__content-head'>
            <p>{t('corporateAccount.modals.deactivate.title')}</p>
            <img
              className='modal__content-exit'
              src='/assets/icons/close.svg'
              alt='close'
              onClick={() => setDeactivateStatus(false)}
            />
          </div>
          <div
            className='modal__content-body'
            style={{display: 'flex', justifyContent: 'center'}}
          >
            {t('corporateAccount.modals.deactivate.message')}
          </div>
          <div className='modal__content-bottom'>
            <button
              className='save danger '
              onClick={() => {
                dispatch(setLoader(true));
                changeStatus({
                  id: currentCorporateAccount?.id,
                  body: {status: 'inactive'},
                })
                  .unwrap()
                  .then(res => {
                    dispatch(setLoader(false));
                    toast.success(t('corporateAccount.messages.corporateDeactivatedSuccess'));
                    setDeactivateStatus(false);
                    getCorporateListFunc();
                  })
                  .catch(err => {
                    dispatch(setLoader(false));
                  });
              }}
            >
              {t('corporateAccount.modals.deactivate.deactivate')}
            </button>
            <button
              className='close almost'
              onClick={() => {
                setDeactivateStatus(false);
              }}
            >
              {t('actions.cancel')}
            </button>
          </div>
        </div>
        <div className='modal__bg'></div>
      </div>
    );
  };

  const renderReactivate = () => {
    return (
      <div className='modal'>
        <div className='modal__content'>
          <div className='modal__content-head'>
            <p>{t('corporateAccount.modals.reactivate.title')}</p>
            <img
              className='modal__content-exit'
              src='/assets/icons/close.svg'
              alt='close'
              onClick={() => setReactivateStatus(false)}
            />
          </div>
          <div className='modal__content-bottom'>
            <button
              className='save danger '
              onClick={() => {
                dispatch(setLoader(true));
                changeStatus({
                  id: currentCorporateAccount?.id,
                  body: {status: 'active'},
                })
                  .unwrap()
                  .then(res => {
                    dispatch(setLoader(false));
                    toast.success(t('corporateAccount.messages.corporateReactivatedSuccess'));
                    setReactivateStatus(false);
                    getCorporateListFunc();
                  })
                  .catch(err => {
                    dispatch(setLoader(false));
                  });
              }}
            >
              {t('corporateAccount.modals.reactivate.reactivate')}
            </button>
            <button
              className='close almost'
              onClick={() => {
                setReactivateStatus(false);
              }}
            >
              {t('actions.cancel')}
            </button>
          </div>
        </div>
        <div className='modal__bg'></div>
      </div>
    );
  };

  const renderTurnCustomForm = () => {
    return (
      <div className='modal'>
        <div className='modal__content'>
          <div className='modal__content-head'>
            <p>
              {t('corporateAccount.modals.turnCustomForm.title', {
                status: currentCorporateAccount?.custom_inspections_enabled
                  ? t('corporateAccount.modals.turnCustomForm.turnOff')
                  : t('corporateAccount.modals.turnCustomForm.turnOn')
              })}
            </p>
            <img
              className='modal__content-exit'
              src='/assets/icons/close.svg'
              alt='close'
              onClick={() => setTurnStatus(false)}
            />
          </div>
          <div
            className='modal__content-body'
            style={{display: 'flex', justifyContent: 'center'}}
          >
            {currentCorporateAccount?.custom_inspections_enabled
              ? t('corporateAccount.modals.turnCustomForm.messageOff')
              : t('corporateAccount.modals.turnCustomForm.messageOn')}
          </div>
          <div className='modal__content-bottom'>
            <button
              className='save danger '
              onClick={() => {
                dispatch(setLoader(true));
                toggleCustomForm(currentCorporateAccount?.id)
                  .unwrap()
                  .then(res => {
                    dispatch(setLoader(false));
                    toast.success(res.message);
                    setTurnStatus(false);
                    getCorporateList({status: type});
                  })
                  .catch(err => {
                    dispatch(setLoader(false));
                    setTurnStatus(false);
                  });
              }}
            >
              {currentCorporateAccount?.custom_inspections_enabled
                ? t('corporateAccount.modals.turnCustomForm.turnOff')
                : t('corporateAccount.modals.turnCustomForm.turnOn')}
            </button>
            <button
              className='close almost'
              onClick={() => {
                setTurnStatus(false);
              }}
            >
              {t('actions.cancel')}
            </button>
          </div>
        </div>
        <div className='modal__bg'></div>
      </div>
    );
  };

  return (
    <Wrapper>
      {deactivateStatus && renderDeactivate()}
      {reactivateStatus && renderReactivate()}
      {turnStatus && renderTurnCustomForm()}
      {createModal && (
        <CorporateCreateModal
          exit={() => {
            setCreateModal(false);
            setCurrentCorporateAccount(null);
          }}
          getCorporateList={getCorporateListFunc}
          currentCorporateAccount={currentCorporateAccount}
        />
      )}
      {editModal && (
        <CorporateEditModal
          exit={() => setEditModal(false)}
          currentCorporateAccount={currentCorporateAccount}
          timezoneOptions={timezoneData?.data?.map(el => ({
            value: el,
            label: el,
          }))}
          getCorporateListFunc={getCorporateListFunc}
        />
      )}

      {inviteModal && (
        <CorporateInviteModal exit={() => setInviteModal(false)} />
      )}
      {pricingModal && (
        <EditCorporatePricingModal
          getCorporateListFunc={getCorporateListFunc}
          currentCorporateAccount={currentCorporateAccount}
          exit={() => setPricingModal(false)}
        />
      )}
      <Helmet>
        <title>
          {type === 'active' ? t('corporateAccount.pageTitle.active') : t('corporateAccount.pageTitle.inactive')}
        </title>
      </Helmet>
      <DashboardHeader
        title={type === 'active' ? t('corporateAccount.title.active') : t('corporateAccount.title.inactive')}
        type='corporate'
        action={() => setCreateModal(true)}
        secondAction={() => setInviteModal(true)}
      />
      <div className='corporate'>
        <div className='corporate__content'>
          <div className='corporate__search'>
            <Input
              type='text'
              placeholder={t('corporateAccount.searchPlaceholder')}
              name='corporateSearch'
              id='corporateSearch'
              image={'/assets/icons/search.svg'}
              maxwidth={264}
              onChange={e => setSearch(e.target.value)}
            />
          </div>
          <div className='corporate__table'>
            <div className='corporate__table-header'>
              <div className='corporate__th'>{t('corporateAccount.tableHeaders.firstName')}</div>
              <div className='corporate__th'>{t('corporateAccount.tableHeaders.lastName')}</div>
              <div className='corporate__th'>{t('corporateAccount.tableHeaders.corporateName')}</div>
              <div className='corporate__th'>{t('corporateAccount.tableHeaders.email')}</div>
              <div className='corporate__th'>{t('corporateAccount.tableHeaders.customForm')}</div>
              <div className='corporate__th'>{t('corporateAccount.tableHeaders.action')}</div>
            </div>
            <div className='corporate__table-body'>
              {filteredCorporate?.length > 0 ? (
                filteredCorporate?.map((item, index) => (
                  <CorporateAccountRow
                    item={item}
                    key={index}
                    data={corporateData}
                    setCorporateData={setCorporateData}
                    setCurrentCorporateAccount={setCurrentCorporateAccount}
                    setPricingModal={setPricingModal}
                    setEditModal={setEditModal}
                    setDeactivateStatus={setDeactivateStatus}
                    setReactivateStatus={setReactivateStatus}
                    setTurnStatus={setTurnStatus}
                    type={type}
                  />
                ))
              ) : (
                <div className='corporate__table-empty'>
                  <img src='/assets/no-data-v3.svg' alt='empty' />
                  <p>{t('corporateAccount.messages.noCorporates')}</p>
                </div>
              )}
            </div>
          </div>
          {/*<CustomPaginate*/}
          {/*  pageCount={corporateData?.pages}*/}
          {/*  handlePageClick={handlePageClick}*/}
          {/*/>*/}
        </div>
      </div>
    </Wrapper>
  );
}
